module.exports = __WEBPACK_EXTERNAL_MODULE_22__;


//////////////////
// WEBPACK FOOTER
// external "@material/react-floating-label/dist/index.js"
// module id = 22
// module chunks = 2 3 6 7